module.exports = __webpack_public_path__ + "img/CloudDoneOutlined.4b71b7ef.svg";